<template>
    <div class="index">
        <div class="banner" ref="banner">
            <video muted="muted"
                src="https://static01.ssrelease.com/0412/M00/73/51/ChR4m2EQwSmACUfPATRjbXKNIy0135.mp4"
                autoplay="autoplay" loop="loop" id="page1Video">
                抱歉，您的浏览器不支持内嵌视频
            </video>
            <img class="ad" src="@/assets/img/index/ad.png" />
            <a v-show="showChunmiao" class="chunmiao-link" href="https://wap.showstart.com/pages/special/springSeed/apply" target="_blank">
                <img class="chunmiao-img" src="@/assets/img/chunmiao-plan.png" />
            </a>
            <div class="text">
                <div class="page-box-layout">
                    <!-- <h1>这个世界需要你的音乐</h1> -->
                    <div class="img"><img src="@/assets/img/index/banner1.png" /></div>
                    <div class="btn-box">
                        <router-link class="btn" :to="userInfo ? '/manage/dashboard' : '/login'">加入秀动发行</router-link>
                    </div>
                </div>
                <div class="next"></div>
            </div>
        </div>
        <block-1></block-1>
        <block-2></block-2>
        <block-3></block-3>
        <block-4></block-4>
        <m-footer></m-footer>
        <!-- <ad :visible.sync="visible"></ad> -->
    </div>
</template>

<script>
import AOS from 'aos';
import MFooter from '@/layout/footer.vue';
import Block1 from './components/block1.vue';
import Block2 from './components/block2.vue';
import Block3 from './components/block3.vue';
import Block4 from './components/block4.vue';
// import Ad from './components/ad.vue';
import 'aos/dist/aos.css';

export default {
    name: 'Index',
    components: {
        Block1,
        Block2,
        Block3,
        Block4,
        MFooter
        // Ad
    },
    data() {
        return {
            visible: false,
            showChunmiao: true
        };
    },
    computed: {
        userInfo() {
            return this.$store.state && this.$store.state.userInfo;
        },
        fileUrl() {
            return this.$fileUrl || (this.$store.state.config && this.$store.state.config.fileUrl);
        }
    },
    mounted() {
        this.$nextTick(() => {
            AOS.init({
                offset: 80,
                duration: 1000,
                easing: 'ease',
                delay: 100,
                once: true
            });
        });
        window.addEventListener('scroll', this.handleScroll);
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll);
    },
    methods: {
        handleScroll() {
            if (this.$refs.banner) {
                const bannerHeight = this.$refs.banner.offsetHeight;
                const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
                this.showChunmiao = scrollTop < bannerHeight;
            }
        }
    }
};
</script>

<style lang="scss">
@keyframes next {
    0% {
        opacity: 1;
        bottom: 90px;
    }

    100% {
        opacity: 0;
        bottom: 80px;
    }
}

.banner {
    position: relative;

    .ad {
        position: absolute;
        top: 50px;
        right: 50px;
        z-index: 101;
        height: 50px;
    }

    .chunmiao-link {
        position: fixed;
        left: 0;
        bottom: 0;
        z-index: 98;
        cursor: pointer;

        .chunmiao-img {
            display: block;
            height: 90px;
        }
    }

    video {
        width: 100%;
        vertical-align: middle;
    }

    .text {
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        background: rgba(0, 0, 0, 0.3);
        align-items: center;
        justify-content: center;
        display: flex;

        .next {
            background: url('~@/assets/img/index/arrowdown.png') center no-repeat;
            width: 16px;
            height: 12px;
            display: inline-block;
            background-size: cover;
            position: absolute;
            bottom: 80px;
            left: 50%;
            margin-left: -8px;
            animation: next 1.2s linear infinite;
        }

        .page-box-layout {
            width: auto;
            margin: 0px;
            text-align: center;
            position: relative;

            // &::before {
            //     content: "";
            //     background: url('~@/assets/img/index/share.png') center no-repeat;
            //     width: 23px;
            //     height: 189px;
            //     position: absolute;
            //     top: 0px;
            //     left: 0px;
            // }
            img {
                width: 860px;
            }

            .btn-box {
                width: 190px;
                display: inline-block;
                margin-top: 40px;
                position: relative;

                a {
                    display: block;
                    height: 54px;
                    border-radius: 27px;
                    text-align: center;
                    line-height: 54px;
                    background-color: $--color-primary;
                    color: #fff;
                }
            }
        }
    }
}
</style>

<style lang="scss" scoped></style>